import axios from './axios';
import { google_auth_url } from '@/config';
import { api as baseURL } from '@/config/index.js';
import * as PusherPushNotifications from '@pusher/push-notifications-web';
import store from '@/store';

const login = async payload => {
	try {
		const { data } = await axios('/auth/login', {
			method: 'post',
			data: payload,
		});

		store.commit('User/setUserProfile', null);
		store.commit('User/setRefreshToken', data.refreshToken);
		store.commit('User/setToken', data.token);
		store.commit('User/setProfile', data.user);
		initBeams(data.user._id, data.token);
		return data;
	} catch (e) {
		console.error(e);
	}
};

const loginWithGoogle = () => {
	window.location.href = google_auth_url;
};

const registerTempUser = async payload => {
	const { data } = await axios('/auth/register-temp', {
		method: 'post',
		data: payload,
	});
	return data;
};

const register = async payload => {
	const { data } = await axios('/auth/register', {
		method: 'post',
		data: {
			payload,
		},
	});
	store.commit('User/setRefreshToken', data.refreshtoken);
	store.commit('User/setToken', data.token);
	store.commit('User/setProfile', data.user);
	return data;
};

const guestRegister = async (payload, token) => {
	const { data } = await axios('/auth/guest/register-guest-person', {
		method: 'post',
		data: payload,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
	store.commit('User/setToken', data.token);
	store.commit('User/setProfile', data.user);
	return data;
};

const evaluateGuestPerson = async (personId, token) => {
	const { data } = await axios(`/auth/guest/evaluate-guest-person/${personId}`, {
		method: 'get',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
	store.commit('User/setToken', data.token);
	store.commit('User/setProfile', data.user);
	return data;
};

const getToken = () => {
	const vuex = JSON.parse(localStorage.getItem('vuex'));
	if (vuex && vuex.User && vuex.User.token) return vuex.User.token;
	else return null;
};

const setUserWithToken = async ({ token, refreshToken }) => {
	store.commit('User/setToken', token);
	store.commit('User/setRefreshToken', refreshToken);
	const { data } = await axios('/user/profile', { method: 'get' });
	store.commit('User/setProfile', data.profile);
	initBeams(data.profile._id, token);
};

const getUser = () => {
	const vuex = JSON.parse(localStorage.getItem('vuex'));
	if (vuex && vuex.User && vuex.User.profile) {
		return vuex.User.profile;
	}
};

const getAdmin = () => {
	const vuex = JSON.parse(localStorage.getItem('vuex'));
	if (vuex && vuex.User) {
		if (vuex.User.profileUser) {
			return vuex.User.profileUser;
		} else return false;
	}
};

const setUser = profile => {
	store.commit('User/setProfile', profile);
};

const setToken = token => {
	store.commit('User/setToken', token);
};

const setRefreshToken = refreshToken => {
	store.commit('User/setRefreshToken', refreshToken);
};

const unSetToken = () => {
	localStorage.removeItem('vuex');
};

const logout = async () => {
	try {
		store.commit('User/setToken', null);
		store.commit('User/setRefreshToken', null);
		store.commit('User/setProfile', {});
		localStorage.removeItem('vuex');
		const beamsClient = new PusherPushNotifications.Client({
			instanceId: process.env.VUE_APP_PUSHER_BEAMS_INSTANCE,
		});
		beamsClient.stop().catch(console.error);
	} catch (e) {
		console.error('Error al cerrar sesion');
	}
};

const loginWith = async function(type, data) {
	switch (type) {
		case 'local':
			return await login(data);
		case 'google':
			loginWithGoogle();
			break;
		case 'google-after-login':
			await setUserWithToken(data);
			break;
	}
};

const initBeams = async (userId, token) => {
	// Si no estamos en produccion no  iniciamos beams
	if (process.env.NODE_ENV !== 'production') return;
	try {
		const tokenProvider = new PusherPushNotifications.TokenProvider({
			url: baseURL + '/beams-auth',
			queryParams: { user_id: userId }, // URL query params your auth endpoint needs
			headers: { Authorization: `Bearer ${token}` }, // Headers your auth endpoint needs
		});
		const beamsClient = new PusherPushNotifications.Client({
			instanceId: process.env.VUE_APP_PUSHER_BEAMS_INSTANCE,
		});
		await beamsClient
			.start()
			.then(() => {
				beamsClient.setUserId(userId, tokenProvider);
			})
			.catch(error => console.error('ERROR BEAMS CLIENTE::', error));
	} catch (e) {
		console.log(e);
	}
};

const loggedIn = () => {
	const vuex = JSON.parse(localStorage.getItem('vuex'));
	if (vuex && vuex.User) {
		const token = vuex.User.token; // Getting token from localstorage
		const user = vuex.User.profile;
		return !!token && !!user; // handwaiving here
	} else return false;
};

export {
	getAdmin,
	evaluateGuestPerson,
	getToken,
	getUser,
	guestRegister,
	loggedIn,
	loginWith,
	logout,
	registerTempUser,
	register,
	setToken,
	unSetToken,
	setUser,
	setRefreshToken,
};
